module.exports = __webpack_public_path__ + "static/results-tear-troughs-after-5e21dba0fd3dfd577932d894000509b2.jpg";